module.exports=[
    {
        path: '/',
        name: '建筑类综合资源平台',
        component: () => import('./views/Platform.vue'),
        meta: {
            noNeedLogin: true, // 判断是否需要登录
        },
        redirect:'/Home',
        children:[
            {
                path: '/Home',
                name: '首页',
                component: () => import('./views/Home.vue'),
            },

            {
                path: '/ExamPaper/:id',
                name: '考试试卷',
                caseSensitive: true,
                component: () => import('./views/exam/ExamPaper.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/ViewExam/:id',
                name: '查看试卷',
                caseSensitive: true,
                component: () => import('./views/exam/ViewExam.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/PreviewExam/:id',
                name: '预览试卷',
                caseSensitive: true,
                component: () => import('./views/exam/PreviewExam.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/Practice/:id',
                name: '练习',
                caseSensitive: true,
                component: () => import('./views/practice/PracticePaper.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/CourseInformation',
                name: '课程中心',
                caseSensitive: true,
                component: () => import('./views/course/CourseInformation.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/CourseInfo/:courseId',
                name: '课程信息',
                caseSensitive: true,
                component: () => import('./views/course/CourseInfo.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/CourseDesign/:courseId',
                name: '课程设计',
                caseSensitive: true,
                component: () => import('./views/course/CourseDesign.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/PersonalCenter',
                name: '个人中心',
                caseSensitive: true,
                component: () => import('./views/personal/PersonalCenter.vue'),
                redirect:"/PersonalCenter/PersonalInfo",
                meta: {
                    requireAuth: true, // 判断是否需要登录
                },
                children:[
                    {
                        path: '/PersonalCenter/PersonalInfo',
                        name: '个人信息',
                        caseSensitive: true,
                        component: () => import('./views/personal/PersonalInfo.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                    {
                        path: '/PersonalCenter/Collection',
                        name: '我的收藏',
                        caseSensitive: true,
                        component: () => import('./views/Collection.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                    {
                        path: '/PersonalCenter/PersonalResource',
                        name: '个人资源',
                        caseSensitive: true,
                        component: () => import('./views/personal/PersonalResource.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },

                    {
                        path: '/PersonalCenter/QuestionBank',
                        name: '题库管理',
                        caseSensitive: true,
                        component: () => import('./views/QuestionBank.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                ]
            },
            {
                path: '/Resource',
                name: '视频资源',
                caseSensitive: true,
                component: () => import('./views/Resource.vue'),
                /*meta: {
                    requireAuth: true, // 判断是否需要登录
                }*/
            },
            {
                path: '/CourseDetail/:courseId',
                name: '课程详情',
                caseSensitive: true,
                component: () => import('./views/course/CourseDetail.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/LearningPath',
                name: '学习轨迹',
                caseSensitive: true,
                component: () => import('./views/LearningPath.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                }
            },
            {
                path: '/WorkShow/:jobId/:userId',
                name: '作业展示',
                caseSensitive: true,
                component: () => import('./views/work/WorkShow.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                },

            },
            {
                path: '/WorkCenter',
                name: '作业中心',
                caseSensitive: true,
                component: () => import('./views/work/WorkCenter.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                },
                children:[
                    {
                        path: '/WorkCenter/WorkResult',
                        name: '作业成绩',
                        caseSensitive: true,
                        component: () => import('./views/work/WorkResult.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                    {
                        path: '/WorkCenter/WorkApproval',
                        name: '作业审批',
                        caseSensitive: true,
                        component: () => import('./views/work/WorkApproval.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },
                    },
                    {
                        path: '/WorkCenter/PublicWork',
                        name: '发布作业',
                        caseSensitive: true,
                        component: () => import('./views/work/PublicWork.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },
                    },
                    {
                        path: '/WorkCenter/MyWork',
                        name: '我的作业',
                        caseSensitive: true,
                        component: () => import('./views/work/MyWork.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },
                    },
                    {
                        path: '/WorkCenter/CompleteWork',
                        name: '已提交作业',
                        caseSensitive: true,
                        component: () => import('./views/work/CompleteWork.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },
                    },
                ]
            },
            {
                path: '/ExamCenter',
                name: '考试中心',
                caseSensitive: true,
                component: () => import('./views/exam/ExamCenter.vue'),
                meta: {
                    requireAuth: true, // 判断是否需要登录
                },
                children:[
                    {
                        path: '/ExamCenter/ExamResult',
                        name: '考试成绩',
                        caseSensitive: true,
                        component: () => import('./views/exam/ExamResult.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                    {
                        path: '/ExamCenter/ResultManage/:courseId',
                        name: '详细成绩',
                        caseSensitive: true,
                        component: () => import('./views/course/ResultDetail.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        }
                    },
                    {
                        path: '/ExamCenter/PublicExam',
                        name: '发布考试',
                        caseSensitive: true,
                        component: () => import('./views/exam/PublicExam.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },
                    },
                    {
                        path: '/ExamCenter/MyExam',
                        name: '我的考卷',
                        caseSensitive: true,
                        component: () => import('./views/exam/MyExam.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },

                    },
                    {
                        path: '/ExamCenter/CompleteExam',
                        name: '已提交试卷',
                        caseSensitive: true,
                        component: () => import('./views/exam/CompleteExam.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },

                    },
                    {
                        path: '/ExamCenter/PublicPractice',
                        name: '发布练习',
                        caseSensitive: true,
                        component: () => import('./views/practice/PublicPractice.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },

                    },
                    {
                        path: '/ExamCenter/PracticeResult',
                        name: '练习成绩',
                        caseSensitive: true,
                        component: () => import('./views/practice/PracticeResult.vue'),
                        meta: {
                            requireAuth: true, // 判断是否需要登录
                        },

                    },

                ]
            },
        ]
    },
    {
        path: '/Software/:id',
        name: '软件',
        component: () => import('./views/soft/Software.vue'),
    },
    {
        path: '/Register',
        name: '用户注册',
        caseSensitive: true,
        component: () => import('./views/Register.vue'),
    },
    {path: '*', component: () => import('./views/404.vue')}
];
